<template>
    <modal :show="show" @close="close()" id="page-create">
        <div class="modal-head">
            <h3>Add Page</h3>
        </div>
        <div class="modal-content">
            <form @submit.prevent="save()">
                <div class="form-control">
                    <label for="path">Enter Path</label>
                    <input type="text" v-model="path" placeholder="/example/path">
                </div>

                <button class="button button-blue">Save</button>
                <button @click.prevent="close()" class="button button-gray">Cancel</button>
            </form>
        </div>
    </modal>
</template>

<script>
import Modal from '@/components/ui/Modal'

export default {
    name: 'PageCreate',
    props: [ 'show' ],
    components: {
        Modal
    },
    data() {
        return {
            path: null
        }
    },
    methods: {
        async save() {
            let response = await this.$http.post('/pingers/' + this.$route.params.id + '/pages', { path: this.path})
            this.path = null
            this.$emit('update')
            this.close()
        },
        close() {
            this.$emit('close')
        }
    }
}
</script>

<style lang="scss">
#page-create {

}
</style>
